import React from 'react';
import ReactDOM from 'react-dom';
import urlUtils from 'esri/urlUtils';
import esriConfig from 'esri/config';
import { App } from 'components/App';

import { validProductIds, defaultStrings } from 'js/config/config';
import { timeLeftInDaysSort } from 'utils/Utilities';
import babelPolyfill from 'babel-polyfill';
import Deferred from 'dojo/Deferred';
import hash from 'dojo/hash';
import io from 'dojo/io-query';

if (!babelPolyfill) {
  console.log('Error: babel-polyfill could not be detected');
}

const validateSSOToken = (GUID) => {
  const origin = 'https://ascehazardtool.org';

  const validateSSOTokenDeferred = new Deferred();
  let xmlhttp = new XMLHttpRequest();
  xmlhttp.open('POST', defaultStrings.customerUrl, true);

  const request =
    '<?xml version="1.0" encoding="utf-8"?>' +
    '<soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">' +
    '<soap:Body><GetCustomerByGUID xmlns="http://asce.org/">' +
    '<GUID>' +
    GUID +
    '</GUID>' +
    '</GetCustomerByGUID></soap:Body></soap:Envelope>';

  xmlhttp.onreadystatechange = () => {
    if (xmlhttp.readyState === 4) {
      // Server returned with OK
      if (xmlhttp.status === 200) {
        const xmlDoc = $.parseXML(xmlhttp.responseText);
        // console.log('Customer Information', xmlDoc);
        const $xml = $(xmlDoc);
        validateSSOTokenDeferred.resolve({
          loggedIn: true,
          MasterCustomerId: $xml.find('MasterCustomerId').text(),
          labelName: $xml.find('LabelName').text(),
          firstName: $xml.find('FirstName').text(),
          lastName: $xml.find('LastName').text(),
          guid: GUID,
        });
      }
      // Server error - Redirect user to ASCE logout page to redirect to our application
      else if (xmlhttp.status === 500) {
        // LOCAL/STAGING
        // window.location.replace(`${defaultStrings.signOutUrl}${defaultStrings.signInUrl}https://localhost/~dnguyendo/ASCE/build/`);

        // PRODUCTION
        window.location.replace(`${defaultStrings.signOutUrl}${defaultStrings.signInUrl}${origin}`);
      }
    }
  };
  xmlhttp.setRequestHeader('Content-Type', 'text/xml');
  xmlhttp.send(request);
  return validateSSOTokenDeferred;
};

const queryLicenseInfo = (userInfo) => {
  const queryUserLicenseInfoDeferred = new Deferred();
  let xmlhttp = new XMLHttpRequest();
  xmlhttp.open('POST', defaultStrings.bluerasterUrl, true);

  const request =
    '<?xml version="1.0" encoding="utf-8"?>' +
    '<soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">' +
    '<soap:Body><ASCE_BR_GetOrderInformation xmlns="http://asce.org/">' +
    '<MasterCustomerID>' +
    userInfo.MasterCustomerId +
    '</MasterCustomerID>' +
    // + '<MasterCustomerID>' + '000011374286' + '</MasterCustomerID>'
    '</ASCE_BR_GetOrderInformation></soap:Body></soap:Envelope>';

  // const request =
  // '<?xml version="1.0" encoding="utf-8"?>' +
  // '<soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">' +
  // '<soap:Body>' +
  // '<ASCE_BR_GetOrdersInformation xmlns="http://asce.org/" />' +
  // '</soap:Body>' +
  // '</soap:Envelope>';

  xmlhttp.onreadystatechange = function () {
    if (xmlhttp.readyState === 4) {
      if (xmlhttp.status === 200) {
        let licenseInfosArray = [];
        let userLicenseInfo = {};

        const xmlDoc = $.parseXML(xmlhttp.responseText);
        // console.log('License Information', xmlDoc);
        const $xml = $(xmlDoc);

        // No licenses - route as logged in but no active license
        if ($xml.find('ASCE_LicenseInfo').text() === '') {
          // console.log('ASCE License Info is empty');
          queryUserLicenseInfoDeferred.resolve({
            loggedIn: true,
            masterCustomerId: userInfo.MasterCustomerId,
            labelName: userInfo.LabelName,
            firstName: userInfo.firstName,
            lastName: userInfo.lastName,
            activeLicense: false,
            GUID: userInfo.guid,
            titleName: userInfo.labelName,
            licenseType: 'SINGLE',
          });
        }

        let licenseInfos = $xml.find('ASCE_LicenseInfo');
        let counter = 0;
        let numberOfLicenses = licenseInfos.length;
        if (numberOfLicenses === 0) {
          queryUserLicenseInfoDeferred.resolve({
            loggedIn: false,
            masterCustomerId: '',
            labelName: '',
            firstName: '',
            lastName: '',
            productId: '',
            startDate: '',
            endDate: '',
            graceDate: '',
            activeLicense: false,
            licenseType: '',
          });
        }
        while (counter < numberOfLicenses) {
          let currentLicense = licenseInfos[counter];
          let $currentLicense = $(currentLicense);

          const startDate = $currentLicense.find('StartDate').text();
          const endDate = $currentLicense.find('EndDate').text();
          const graceDate = $currentLicense.find('GraceDate').text();
          const timeLeftInDays = window.moment(endDate, 'MM/DD/YYYY').diff(window.moment(), 'days');

          const license = {
            loggedIn: true,
            masterCustomerId: $currentLicense.find('MasterCustomerId').text(),
            labelName: $currentLicense.find('LabelName').text(),
            firstName: $currentLicense.find('FirstName').text(),
            lastName: $currentLicense.find('LastName').text(),
            productId: $currentLicense.find('ProductID').text(),
            startDate: startDate,
            endDate: endDate,
            graceDate: graceDate,
            timeLeftInDays: timeLeftInDays,
            activeLicense: $currentLicense.find('LineStatus').text(),
            licenseType: $currentLicense.find('LicenseType').text(),
            titleName: userInfo.labelName,
            GUID: userInfo.guid,
          };

          licenseInfosArray.push(license);
          counter++;
        }

        if (licenseInfosArray.length > 1) {
          let singleLicenses = [],
            corporateLicenses = [];
          const todaysDate = window.moment(new Date());

          // Categorize by license type
          licenseInfosArray.forEach((license) => {
            if (
              license.licenseType.toLowerCase() === 'license holder' ||
              license.licenseType.toLowerCase() === 'license access'
            ) {
              corporateLicenses.push(license);
            } else {
              singleLicenses.push(license);
            }
          });

          // Prioritize the licenses by type and choose the license with the greatest number of days left whose startDate is on or before today's date
          if (corporateLicenses.length >= 1) {
            corporateLicenses.sort(timeLeftInDaysSort);
            let nextStartDate,
              goodIndex = 0;

            do {
              if (window.moment(corporateLicenses[goodIndex].startDate, 'MM/DD/YYYY') > todaysDate) {
                nextStartDate = corporateLicenses[goodIndex].startDate;
                goodIndex++;
              }
            } while (window.moment(corporateLicenses[goodIndex].startDate, 'MM/DD/YYYY') > todaysDate);

            userLicenseInfo = corporateLicenses[goodIndex];
            userLicenseInfo.nextStartDate = nextStartDate;

            if (userLicenseInfo.graceDate < userLicenseInfo.nextStartDate) {
              const gapInDays = window
                .moment(userLicenseInfo.nextStartDate, 'MM/DD/YYYY')
                .diff(window.moment(userLicenseInfo.graceDate, 'MM/DD/YYYY'), 'days');
              userLicenseInfo.daysBeforeNewStartDate = gapInDays;
            }
          } else {
            singleLicenses.sort(timeLeftInDaysSort);
            let nextStartDate,
              goodIndex = 0;

            do {
              if (window.moment(singleLicenses[goodIndex].startDate, 'MM/DD/YYYY') > todaysDate) {
                nextStartDate = singleLicenses[goodIndex].startDate;
                goodIndex++;
              }
            } while (window.moment(singleLicenses[goodIndex].startDate, 'MM/DD/YYYY') > todaysDate);

            userLicenseInfo = singleLicenses[goodIndex];
            userLicenseInfo.nextStartDate = nextStartDate;

            if (userLicenseInfo.graceDate < userLicenseInfo.nextStartDate) {
              const gapInDays = window
                .moment(userLicenseInfo.nextStartDate, 'MM/DD/YYYY')
                .diff(window.moment(userLicenseInfo.graceDate, 'MM/DD/YYYY'), 'days');
              userLicenseInfo.daysBeforeNewStartDate = gapInDays;
            }
          }
        }
        // Only a single license was returned
        else {
          userLicenseInfo = licenseInfosArray[0];
        }

        // Multiple licenses to be checked
        if (!validProductIds.includes(userLicenseInfo.productId)) {
          userLicenseInfo.activeLicense = false;
        }

        queryUserLicenseInfoDeferred.resolve(userLicenseInfo);
      } else {
        queryUserLicenseInfoDeferred.resolve({
          loggedIn: true,
          masterCustomerId: userInfo.MasterCustomerId,
          labelName: userInfo.LabelName,
          firstName: userInfo.firstName,
          lastName: userInfo.lastName,
          productId: '',
          startDate: '',
          endDate: '',
          graceDate: '',
          activeLicense: false,
          licenseType: '',
        });
      }
    }
  };
  // Send the POST request
  xmlhttp.setRequestHeader('Content-Type', 'text/xml');
  xmlhttp.send(request);

  return queryUserLicenseInfoDeferred;
};

function removeGUID() {
  let queryParameters = window.location.search.substring(1);
  if (queryParameters.length) {
    if (window.history !== undefined && window.history.pushState !== undefined) {
      window.history.pushState({}, document.title, window.location.pathname);
    }
  }
}

const getLoginInfo = () => {
  const infoDeferred = new Deferred();
  // Splits off any hash information
  // const url = document.URL.split('#')[0] || false;
  // const token = url.split('GUID=')[1] || false;
  // if (token) {
  //   validateSSOToken(token).then((result) => {
  //     if (result.loggedIn) {
  //       queryLicenseInfo(result).then((license) => {
  //         infoDeferred.resolve(license);
  //         removeGUID();
  //       });
  //     } else {
  //       infoDeferred.resolve({ loggedIn: false });
  //       removeGUID();
  //     }
  //   });
  // } else {
  //   infoDeferred.resolve({ loggedIn: false });
  //   removeGUID();
  // }
  infoDeferred.resolve({ loggedIn: true, activeLicense: 'A' });
  removeGUID();
  return infoDeferred;
};

const initProxy = () => {
  // Development if not on production or beta urls
  const DEVELOPMENT =
    !window.location.origin.includes('ascehazardtool.org') && !window.location.origin.includes('asce.org');

  //                                  ↓ DEVELOPMENT ↓      ↓ PRODUCTION ↓
  const proxyUrl = DEVELOPMENT ? 'proxy/proxy.php' : 'proxy/proxy.ashx';

  esriConfig.defaults.io.alwaysUseProxy = false;
  esriConfig.defaults.io.proxyUrl = proxyUrl;

  urlUtils.addProxyRule({
    urlPrefix: 'https://gis.asce.org/arcgis/rest/services/ASCE',
    proxyUrl: proxyUrl,
  });

  urlUtils.addProxyRule({
    urlPrefix: 'https://hdsc.nws.noaa.gov/cgi-bin/new/cgi_readH5.py',
    proxyUrl: proxyUrl,
  });
};

let initializeApp = () => {
  require([
    'app/vendor/jquery/dist/jquery.min.js',
    'app/vendor/velocity/velocity.min.js',
    'app/vendor/moment/moment.js',
  ], function ($, velocity, moment) {
    initProxy();

    window.jQuery.velocity = velocity;
    window.moment = moment;
    let oScript = document.createElement('script');
    oScript.type = 'text/javascript';
    oScript.onload = function () {
      getLoginInfo().then((result) => {
        // Need to manipulate date here with moment
        result.startDate = moment(result.startDate, 'M-D-YYYY');
        result.endDate = moment(result.endDate, 'M-D-YYYY');
        result.graceDate = moment(result.graceDate, 'M-D-YYYY');
        // result.timeLeftInDays = result.endDate.diff(moment(), 'days');
        result.today = moment(new Date());

        // Get hash from url
        const hashObject = io.queryToObject(hash());

        // If the hash only contains a SINGLE LOAD - it passes a string and not an array - handle issue here
        if (Object.keys(hashObject).length !== 0 && hashObject.constructor === Object && !Array.isArray(hashObject.l)) {
          hashObject.l = [hashObject.l];
        }

        ReactDOM.render(<App userInfo={result} hash={hashObject} />, root);
      });
    };
    document.getElementsByTagName('head')[0].appendChild(oScript);
    oScript.src = 'app/vendor/Materialize/dist/js/materialize.min.js';
  });
};

initializeApp();
